import React from 'react';
import { withRouter } from 'react-router-dom'

class FixedFloater extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            hover: false
        };

        this.toggleHover.bind(this);
        this.gotoLink = this.gotoLink.bind(this);
    }

    toggleHover(e) {
        if(this) {
            this.setState(
                {
                    hover: !this.state.hover
                }
            );
            console.log("toggleHover()");
        }
        e.stopPropagation();
    }

    gotoLink() {
        this.props.history.push(this.props.pushTo);
    }

    render() {

        var floaterStyle = {
            cursor: "pointer",
            color: "#fff",
            backgroundColor: this.props.background,
            borderRadius: 6,
            padding: 10,
            position: "fixed",
            bottom: 10,
        }

        var floaterHoverStyle = {
            cursor: "pointer",
            color: "#000",
            backgroundColor: this.props.background,
            borderRadius: 6,
            padding: 10,
            position: "fixed",
            bottom: 10,
        }

        var currStyle = floaterStyle;
        if(this.state.hover) currStyle = floaterHoverStyle;
        if("right" in this.props) { currStyle.right = parseInt( this.props.right, 10); }
        if("left" in this.props) { currStyle.left = parseInt( this.props.left, 10); }

        return (
            <div
                style={currStyle}
                onClick={this.gotoLink}
                onMouseOver={(e) => this.toggleHover(e)}
                onMouseOut={(e) => this.toggleHover(e)}
            >
                {this.props.text}
            </div>
        );
    }
}

export default withRouter(FixedFloater)


// WEBPACK FOOTER //
// src/static/FixedFloater.js